<template>
    <v-tooltip-wrapper
        :contentClass="`tooltip-glass tooltip-white elevation-8 tooltip-border-colored ${tooltipBorderClass}`"
        :max-width="420"
        :open-delay="delayedTooltip ? 150 : 0"
        :tooltip-position="tooltipPosition"
        :transition="tooltipTransition">
        <template #activator="{ on, attrs }">
            <div :class="containerClasses"
                 :style="containerStyles"
                 class="element-state-icon-container"
                 v-bind="{...$attrs, ...( showTooltip ? attrs : {} )}"
                 v-on="{...$listeners, ...( showTooltip ? on : {} )}">
                <i :class="iconClass"
                   class="far element-state-icon" />
            </div>
        </template>
        {{ stateMessage }}
    </v-tooltip-wrapper>
</template>

<script>
import {
    getStateBorderClass,
    getStateColor,
    getStateIcon,
    getStateMessage,
    getStateTextColor
} from '../../../../utils/publish'
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default {
    inheritAttrs: false,
    components: { VTooltipWrapper },
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {
            default: {}
        }
    },
    props: {
        /** @type {PublishState} */
        state: String,
        size: {
            type: String,
            default: 'medium'
        },
        coloredShadow: Boolean,
        onlyBottomStartBorderRounded: Boolean,
        backgroundSemitransparent: Boolean,
        showTooltip: Boolean,
        delayedTooltip: Boolean,
        /** @type {'top'|'bottom'|'left'|'right'} */
        tooltipPosition: {
            type: String,
            default: 'top'
        },
        tooltipTransition: String,
        classes: String
    },
    computed: {
        backgroundColor() {
            return getStateColor(this.stateComputed)
        },
        textColor() {
            return getStateTextColor(this.stateComputed)
        },
        iconClass() {
            return getStateIcon(this.stateComputed)
        },
        /** @returns {Partial<CSSStyleDeclaration>}*/
        containerStyles() {
            return {
                '--element-state-color-bg': this.backgroundColor,
                color: this.textColor
            }
        },
        containerClasses() {
            return [
                {
                    'border-only-bottom-start': this.onlyBottomStartBorderRounded,
                    'bg-semitransparent': this.backgroundSemitransparent,
                    'colored-shadow': this.coloredShadow,
                    'element-state-small': this.size == 'small',
                    'element-state-medium': this.size == 'medium',
                    'element-state-large': this.size == 'large'
                },
                this.classes
            ]
        },
        tooltipBorderClass() {
            // return getStateBorderClass(this.stateComputed)
        },
        stateMessage() {
            return getStateMessage(this.stateComputed)
        },
        stateComputed() {
            return this.state ?? this.publishInfoTable.element.state
        }
    }
}
</script>
